import { coreApi } from '$api'
import { IPaySummaryReportResponse } from '$models'
import { singletonQueryClient } from '$utils'
import { Dayjs } from 'dayjs'

enum QueryKeys {
  getPaySummaryReport = 'pay-summary-report',
}

/**
 * `staleTime: 0` keeps a finished report out of it, so the refetch after a
 * shift edit still gets the new figures.
 */
export const getReport = async (
  startDateTime: Dayjs,
  endDateTime: Dayjs
): Promise<IPaySummaryReportResponse> =>
  singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.getPaySummaryReport, startDateTime, endDateTime],
    queryFn: ({ signal }) =>
      coreApi.getPaySummaryReport(startDateTime, endDateTime, signal),
    staleTime: 0,
  })
